// extracted by mini-css-extract-plugin
export var linkText = "_oe-0";